<div class="modal-header">
  <div class="d-flex align-items-center gap-2">
    <div class="modal-title" i18n>Contact Details</div>
  </div>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-md-6">
        <app-user-select
          [multiple]="false"
          [ctrl]="userCtrl"
          (selected)="onUserSelect($event)"
          label="Auto-fill from existing user"
          i18n-label
          placeholder="Select User"
          i18n-placeholder
        ></app-user-select>
      </div>
      <div class="col-md-6">
        <mat-form-field2 class="mat-block">
          <app-select
            placeholder="Contact Profile"
            [items]="contactProfileTypes"
            [required]="true"
            [multiple]="true"
            formControlName="contact_profiles"
            matTooltip="A General contact must be added first before adding any other contact types."
            i18n-matTooltip
          >
            <ng-template selectLabel let-items="items">
              <span *ngFor="let t of items; let last = last">
                {{ t | titleCase }}<ng-container *ngIf="!last">, </ng-container>
              </span>
            </ng-template>
            <ng-template selectItem let-item="item">{{ item | titleCase }}</ng-template>
          </app-select>
          <mat-error *ngIf="form.get('contact_profiles').touched && form.get('contact_profiles').hasError('required')">
            <ng-container i18n>Profile is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-md-6">
        <mat-form-field2 class="mat-block">
          <input
            type="email"
            formControlName="email"
            matInput
            required
            i18n-placeholder
            placeholder="Email"
            autocomplete="off"
          />
          <mat-error *ngIf="form.get('email').touched && form.get('email').hasError('required')" i18n>
            Email is required
          </mat-error>
          <mat-error *ngIf="form.get('email').touched && form.get('email').hasError('email')" i18n>
            Email must have valid format
          </mat-error>
        </mat-form-field2>
      </div>
      <ng-container [formGroup]="personForm">
        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <input type="text" matInput formControlName="name" placeholder="Name" i18n-placeholder required />
            <mat-error *ngIf="personForm.get('name').touched && personForm.get('name').hasError('required')">
              <ng-container i18n>Name is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <app-select
              placeholder="Job title"
              [items]="jobs"
              [required]="true"
              [multiple]="false"
              formControlName="job_title"
            >
            </app-select>
            <mat-error *ngIf="personForm.get('job_title').touched && personForm.get('job_title').hasError('required')">
              <ng-container i18n>Job Title is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <app-language-select
            [items]="languages"
            [ctrl]="personForm.get('language_code')"
            [showBlankItem]="false"
          ></app-language-select>
        </div>
      </ng-container>
    </div>
  </form>
  <hr />
  <h6 i18n>Contact Phone Numbers</h6>
  <div class="d-flex gap-3" *ngFor="let item of phonesArray.controls; let index = index" [formGroup]="item">
    <div class="flex-2">
      <mat-form-field2 class="mat-block">
        <input type="text" matInput formControlName="phone_number" placeholder="Number" i18n-placeholder required />
        <mat-error *ngIf="item.get('phone_number').touched && item.get('phone_number').hasError('required')">
          <ng-container i18n>Number is required</ng-container>
        </mat-error>
      </mat-form-field2>
    </div>
    <mat-form-field2 class="flex-1">
      <mat-label i18n>Type</mat-label>
      <mat-select formControlName="phone_tech_type" required>
        <mat-option *ngFor="let t of phoneTechTypes" [value]="t.id">
          {{ t.label }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="item.touched && item.hasError('required')">
        <ng-container i18n>Type is required</ng-container>
      </mat-error>
    </mat-form-field2>
    <mat-form-field2 class="flex-1">
      <input type="text" matInput formControlName="extension" placeholder="Ext." />
      <mat-error *ngIf="item.get('extension').touched && item.get('extension').hasError('required')">
        <ng-container i18n>Extension is required</ng-container>
      </mat-error>
    </mat-form-field2>
    <button class="btn btn-danger align-input-row-end" (click)="onRemovePhone(index)">
      <i class="cs-icon cs-icon-trash"></i>
    </button>
  </div>
  <button class="btn btn-secondary-info" (click)="onAddPhone()">
    <i class="far fa-plus"></i>
    <ng-container i18n>Add Phone Number</ng-container>
  </button>

  <hr />
  <h6 i18n>Contact Address</h6>

  <div>
    <div class="row" [formGroup]="addressForm">
      <div class="col-md-12">
        <mat-form-field2 class="mat-block">
          <input type="text" matInput formControlName="address_line" placeholder="Address" i18n-placeholder required />
          <mat-error
            *ngIf="addressForm.get('address_line').touched && addressForm.get('address_line').hasError('required')"
          >
            <ng-container i18n>Address is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-md-6">
        <mat-form-field2 class="mat-block">
          <input type="text" matInput formControlName="city_name" placeholder="City" i18n-placeholder required />
          <mat-error *ngIf="addressForm.get('city_name').touched && addressForm.get('city_name').hasError('required')">
            <ng-container i18n>City is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-md-6">
        <app-country-select placeholder="Country" [codeCtrl]="addressForm.get('country_code')"></app-country-select>
      </div>
      <div class="col-md-6">
        <mat-form-field2 class="mat-block">
          <input type="text" matInput formControlName="postal_code" placeholder="Postal Code" i18n-placeholder />
        </mat-form-field2>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="onSave(form)" type="button" class="btn btn-secondary-info" [disabled]="isLoading">
    <i class="far fa-spinner fa-spin" *ngIf="isLoading"></i>
    <i class="cs-icon cs-icon-save" *ngIf="!isLoading"></i>
    <ng-container i18n>Save</ng-container>
  </button>
</div>
